module.exports = __webpack_public_path__ + "img/share.31f590e7.svg";